<template>
  <v-card>
    <v-toolbar card color="white">
      <NotificationsFilters @search="localPagination.page = 1" />
      <v-text-field
        v-model="localFilters.match"
        :placeholder="$t('action.buttons.search')"
        flat
        hide-details
        prepend-icon="search"
        solo
      />
      <meta-button type="new" @click="setNew" />
    </v-toolbar>
    <v-divider />
    <v-card-text class="pa-0">
      <v-data-table
        :items="formatedList"
        :headers="headers"
        :rows-per-page-items="[10, 25, 50]"
        :loading="loading"
        disable-initial-sort
        item-key="_id"
        :total-items="localPagination.totalItems"
        :pagination.sync="localPagination"
      >
        <template slot="items" slot-scope="props">
          <td
            v-if="
              !props.item.send &&
              !props.item.sendMail &&
              new Date(props.item.sendDate).getTime() < new Date().getTime()
            "
            class="text-xs-center px-0"
          >
            <v-icon
              v-if="can('edit', 'notification')"
              color="success"
              class="mr-1"
              @click="setOne(props.item._id)"
            >
              edit
            </v-icon>
            <v-icon
              v-if="can('delete', 'notification')"
              color="error"
              @click="ifDelete(props.item._id)"
            >
              delete
            </v-icon>
          </td>
          <td v-else class="text-xs-center px-0">
            <v-icon color="primary" class="mr-1" @click="view(props.item._id)">
              visibility
            </v-icon>
          </td>
          <td class="text-xs-center">
            <button-state
              :state="props.item.send || props.item.sendMail || false"
            />
          </td>
          <td class="text-xs-center" style="min-width: 180px">
            {{ props.item.sendDate }}
          </td>
          <td>{{ props.item.title }}</td>
          <td class="text-xs-center">
            {{ props.item.type }}
          </td>
          <td style="min-width: 150px">
            {{ props.item.createdBy }}
          </td>
          <td class="text-xs-center" style="min-width: 180px">
            {{ props.item.createdAt }}
          </td>
          <td class="text-xs-center">
            <i
              class="icon material-icons cursor"
              @click="openUpdated(props.item._id)"
              >visibility</i
            >
          </td>
        </template>
      </v-data-table>
    </v-card-text>
    <dialog-delete
      :dialog.sync="dialogDelete"
      :loading="loading"
      @delete="_setDelete(idDelete)"
    />
    <dialog-updated-record :dialog.sync="dialogUpdated" :updated="updated" />
  </v-card>
</template>

<script>
import { debounce } from 'debounce'
import { mapActions, mapState, mapGetters } from 'vuex'
import NotificationsFilters from './NotificationsFilters'
import DialogDelete from '@/components/widgets/dialog/DialogDelete'
import DialogUpdatedRecord from '@/components/widgets/dialog/DialogUpdatedRecord'
import { parseObject } from '@/helpers/utils'

export default {
  name: 'NotificationList',
  components: {
    DialogDelete,
    DialogUpdatedRecord,
    NotificationsFilters,
  },
  data() {
    return {
      idDelete: '',
      idClone: '',
      dialogDelete: false,
      dialogClone: false,
      dialogUpdated: false,
    }
  },
  watch: {
    dialogUpdated(val) {
      if (!val) this.reset()
    },
    'filters.match': {
      handler: function (/* val, oldVal */) {
        if (this.localPagination.page !== 1) this.localPagination.page = 1
        this.debounceFetch('notifications')
      },
    },
    'localPagination.page': {
      handler: function (/* val, oldVal */) {
        this.debounceFetch('notifications')
      },
    },
    'localPagination.rowsPerPage': {
      handler: function (/* val, oldVal */) {
        this.debounceFetch('notifications')
      },
    },
    'localPagination.sortBy': {
      handler: function (/* val, oldVal */) {
        this.debounceFetch('notifications')
      },
    },
    'localPagination.descending': {
      handler: function (/* val, oldVal */) {
        this.debounceFetch('notifications')
      },
    },
  },
  computed: {
    ...mapState({
      loading: (state) => state.notifications.loading,
      selected: (state) => state.notifications.selected,
      pagination: (state) => state.notifications.pagination,
      filters: (state) => state.notifications.filters,
      receiverList: (state) => state.notifications.receiverList,
      receiverPagination: (state) => state.notifications.receiverPagination,
      receiverFilters: (state) => state.notifications.receiverFilters,
    }),
    ...mapGetters({
      formatedList: 'notifications/formatedList',
      receiverList: 'notifications/receiverList',
    }),
    headers() {
      return [
        {
          text: this.$t('fields.global.actions'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('titles.notifications.send'),
          align: 'center',
          value: 'send',
        },
        {
          text: this.$t('titles.notifications.sendDate'),
          align: 'center',
          value: 'sendDate',
        },
        {
          text: this.$t('titles.notifications.title'),
          value: 'title',
        },
        {
          text: this.$t('fields.global.type'),
          align: 'center',
          value: 'type',
        },
        {
          text: this.$t('fields.global.createdBy'),
          value: 'createdBy',
        },
        {
          text: this.$t('fields.global.createdAt'),
          align: 'center',
          value: 'createdAt',
          sortable: false,
        },
        {
          text: this.$t('fields.global.updatedAt'),
          align: 'center',
          value: 'updatedAt',
          sortable: false,
        },
      ]
    },
    localFilters: {
      get() {
        return this.filters
      },
      set(value) {
        this.$store.commit('notifications/setFilters', value)
      },
    },
    localPagination: {
      get() {
        return this.pagination
      },
      set(value) {
        this.$store.commit('notifications/setPagination', value)
      },
    },
    updated() {
      if (!Array.isArray(this.selected.updated)) return []
      return this.selected.updated
    },
  },
  methods: {
    ...mapActions({
      fetchOne: 'notifications/fetchOne',
      setCreate: 'notifications/create',
      setDelete: 'notifications/delete',
      reset: 'notifications/reset',
      fetchList: 'notifications/fetchList',
      fetchReceivers: 'notifications/fetchReceivers',
      fetchStats: 'notifications/fetchStats',
    }),
    setOne(id) {
      this.$emit('clear')
      this.fetchOne(id).then(() => this.$emit('form'))
    },
    view(id) {
      this.fetchOne(id).then(() => {
        this.fetchReceivers(id)
        this.fetchStats(id)
        this.$emit('view')
      })
    },
    setNew() {
      this.$emit('clear')
      this.$emit('form')
    },
    openUpdated(id) {
      this.$emit('clear')
      this.fetchOne(id).then(() => (this.dialogUpdated = true))
    },
    ifClone(id) {
      this.idClone = id
      this.dialogClone = true
    },
    setClone(id) {
      this.fetchOne(id).then((notification) => {
        let payload = parseObject(notification)
        delete payload._id
        payload.name.forEach((item) => (item.text += ' (copy)'))
        this.setCreate(payload).then(() => (this.dialogClone = false))
      })
    },
    ifDelete(id) {
      this.idDelete = id
      this.dialogDelete = true
    },
    _setDelete(id) {
      this.setDelete(id).finally(() => (this.dialogDelete = false))
    },
    debounceFetch: debounce(function () {
      this.fetchList()
    }, 1000),
  },
}
</script>
